import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'contact-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  name: string;
  email: string;
  tel: string;
  message: string;

  onSubmit() {
    console.log(this.name);
    console.log(this.email);
    console.log(this.tel);
    console.log(this.message);
  }

  constructor() { }

  ngOnInit() {
  }

}
